import { Outlet } from "@tanstack/react-router";
import { LoadingOverlay } from "components/layout/LoadingOverlay";
import { Suspense } from "react";

export const VendorLayout = () => {
    return (
        <Suspense fallback={<LoadingOverlay />}>
            <Outlet />
        </Suspense>
    );
};
